import React from 'react';
import { connect } from 'react-redux';
import {
  LocalForm,
  Control
} from 'react-redux-form';
import Errors from './Errors'

import { Redirect } from 'react-router-dom'

import {
  is_logged_on,
  is_validating,
  is_admin
} from "../helpers"

import {
  create_account_init,
  create_account,
  reset_account_errors
} from '../actions'

const mapStateToProps = state => {
  return {
    current_user: state.auth.current_user.data,
    errors: state.account.errors,
    must_redirect: state.account.must_redirect
  };
}

const mapDispatchToProps = dispatch => {
  return {
    createAccount: values => dispatch( create_account(values) ),
    initState: () => dispatch( create_account_init() ),
    resetErrors: () => dispatch ( reset_account_errors() )
  };
}

class ConnectedAccountNew extends React.Component {
  constructor() {
    super()
    this.state = {
      redirect: false
    }
  }

	handleSubmit(values) {
    console.log(values)

    this.props.createAccount(values)

	}

  cancel() {
    this.setState({redirect: true})
  }

  componentWillUnmount() {
    this.props.initState()
  }

	render() {
    if ( ( !is_validating() && !is_logged_on() ) || ( !is_validating() && !is_admin() ) ) {
      return <Redirect to="/" />
    }

    if ( this.props.must_redirect || this.state.redirect ) {
      return <Redirect to="/accounts" />
    }

		return (
			<div className="collection with-header">
				<div className="collection-header red darken-1 white-text">
					<span className="flow-text">Add New Account</span>
					<i className="material-icons right">library_add</i>
				</div>

        <LocalForm
        className="collection-item"
        model="localAccount"
        onSubmit = { (values) => {
          this.handleSubmit(values)
        }}
        initialState={{
          name: "",
          description: ""
        }}
        >

					<div className="section">
						<div className="input-field">
							<label htmlFor="account_name" >Account Name</label>
							<Control.text id="account_name" model= ".name" required/>
						</div>
					</div>

					<div className="section">
						<div className="input-field">
            <label htmlFor="account_description">Account description</label>
            <Control.textarea id="account_description" model= ".description" className="materialize-textarea"/>
						</div>
					</div>

					<div className="section">
            <a href="" className="btn red darken-1 waves-effect waves-light mr-10" onClick={(e)=>{
              e.preventDefault()
              this.cancel()
            }}>Cancel</a>
						<button type="submit" className="btn red darken-1 waves-effect waves-light">Create Account <i className="material-icons right">navigate_next</i></button>
					</div>
          <Errors errors={this.props.errors}/>
				</LocalForm>

			</div>
		)
	}
}

const AccountNew = connect(mapStateToProps, mapDispatchToProps)(ConnectedAccountNew);

export default AccountNew;



// WEBPACK FOOTER //
// ./src/js/components/AccountNew.js